/** Wire shape of `GET|PUT /api/memo/:shortName` — the response projection, not the stored document. */
export interface Memo {
  _id?: string;
  shortName: MemoShortName | string;
  content: string;
  updatedAt?: string;
}

export enum MemoShortName {
  CatalogManagerApproval = 'catalog-manager-approval',
}
